export default __webpack_public_path__ + "static/media/gallery_01.6f9a5bb1.jpg";